const tableConstantsAR = {
  recordsSelected: 'عدد السجلات المحددة ',
  total: 'مجموع  ',
  records: 'السجلات',
  filter: 'تصفية',
};

export default tableConstantsAR;
